/**
 * Main.js
 *
 * @since 1.0.0
 */

import 'objectFitPolyfill'
import objectFitImages from 'object-fit-images'
import LazyLinePainter from 'lazy-line-painter'
import ScrollMonitor from './modules/ScrollMonitor'
import * as Sentry from '@sentry/browser'
import ObserveFontFace from './modules/ObserveFontFace'
import FormValidation from './modules/FormValidation'
import SendForm from './modules/SendForm'
import DependsOn from './modules/DependsOn'
import LazyLoadImage from './modules/LazyLoadImage'
import LazyLoadPicture from './modules/LazyLoadPicture'
import LazyLoadVideo from './modules/LazyLoadVideo'
import Menu from './modules/Menu'
import FullsizeSlider from './modules/FullsizeSlider'
import Marker from './modules/Marker'
import VideoBlock from './modules/VideoBlock'
import Compare from './modules/Compare'
import Onscroll from './modules/Onscroll'
import Lightbox from './modules/Lightbox'
import SwipeOneSlider from './modules/SwipeOneSlider'
import PageScroller from './modules/PageScroller'
import AutoSlider from './modules/AutoSlider'
import DrawIcon from './modules/DrawIcon'
import SwipeOffsetSlider from './modules/SwipeOffsetSlider'

;(function IIFE() {
  if (process.env.NODE_ENV === 'production') {
    Sentry.init({
      dsn:
        'https://6ec8aff2eefc494dbe89ed4cbd718583@o36959.ingest.sentry.io/5199627'
    })
  }

  ObserveFontFace()
  objectFitImages()
  FormValidation()
  SendForm()
  DependsOn()
  LazyLoadImage()
  LazyLoadPicture()
  LazyLoadVideo()
  Menu()
  FullsizeSlider()
  Marker()
  VideoBlock()
  Compare()
  Onscroll()
  Lightbox()
  PageScroller()
  SwipeOneSlider()
  DrawIcon()
  ScrollMonitor()
  AutoSlider()
  SwipeOffsetSlider()
})()



// WEBPACK FOOTER //
// ./src/js/main.js